import React from 'react';
import PropTypes from 'prop-types';
import EditButton from '../styled/EditButton';

const AdminEditLink = props => {
  const { adminBaseUrl, productId, productVersionId } = props;

  return adminBaseUrl ? (
    <EditButton
      data-cy="edit-button"
      href={`${adminBaseUrl}/admin/mkt_product/edit_product/${productId}#${productVersionId}`}
    >
      EDIT
    </EditButton>
  ) : null;
};

AdminEditLink.defaultProps = {
  adminBaseUrl: null,
};

AdminEditLink.propTypes = {
  adminBaseUrl: PropTypes.string,
  productId: PropTypes.string.isRequired,
  productVersionId: PropTypes.string.isRequired,
};

export default AdminEditLink;
